import { GridType } from "../../../../Entities/GridType";
import { CompareScenarios } from "./CompareScenarios";

export const CompareAllocationView = () => {
	return <CompareScenarios gridType={GridType.Allocation} />
}